import type { Dayjs } from "dayjs";
import Cookies from "js-cookie";
import type { NextRequest } from "next/server";

import dayjs, { toDate } from "@/utils/dayjs";
import { CookiesItemEnum } from "@/utils/enums/CookiesItemEnum";

export function getCookies(item: CookiesItemEnum): string | undefined {
  const cookieValue = Cookies.get(item);
  return cookieValue || undefined;
}

export function setCookies(
  item: CookiesItemEnum,
  value: any,
  haveExpiredDate?: boolean,
  expiredDate?: Dayjs,
): void {
  // eslint-disable-next-line no-nested-ternary
  const expDate = expiredDate
    ? toDate(expiredDate)
    : haveExpiredDate
      ? toDate(dayjs().add(1, "year"))
      : undefined;

  Cookies.set(item, String(value), {
    ...(expDate && { expires: expDate }),
    secure: item !== CookiesItemEnum.BEARER_TOKEN,
    sameSite: "Lax",
  });
}

export function removeCookies(item: CookiesItemEnum): void {
  Cookies.remove(item);
}

export function clearAllCookies(): void {
  Object.keys(Cookies.get()).forEach((cookieName) => {
    if (cookieName === CookiesItemEnum.ADVERTISING_COOKIES) {
      return;
    }
    if (cookieName === CookiesItemEnum.NECESSARY_COOKIES) {
      return;
    }

    Cookies.remove(cookieName);
  });
}

export function extendCookie(cookieName: CookiesItemEnum) {
  const cookieValue: string | undefined = getCookies(cookieName);

  // Calculate the expiration date to be 1 year from now
  const expiredDate = toDate(dayjs().add(1, "year"));

  if (cookieValue !== undefined) {
    // Remove the existing cookie
    Cookies.remove(cookieName);

    // Set the cookie with the new expiration date
    Cookies.set(cookieName, cookieValue, { expires: expiredDate });
  } else {
    // Uncomment the next line to log an error if the cookie is not found
    // console.error(`Cookie with name ${cookieName} not found.`);
  }
}

export function setCookieInRequestMiddleware(
  req: NextRequest,
  cookieName: CookiesItemEnum,
  cookieValue: any,
) {
  req.headers.set(cookieName, cookieValue);
  req.cookies.set(cookieName, String(cookieValue));

  return req;
}

export function getCookieInRequestMiddleware(
  req: NextRequest,
  cookieName: CookiesItemEnum,
): string | undefined {
  const cookiesValue = req.cookies.get(cookieName)?.value;

  return cookiesValue || undefined;
}
